import { RouterItemType } from "@/app/index";
import { BusinessUnitItemType } from "@/schemas/index";
import { serviceBusinessUnitsApi } from "@/services/business-units";
import { lazy } from "react";

const LayoutPageBusinessUnit = lazy(() => import("./layout/index"));

export type LoaderDataBusinessUnitType = {
  businessUnit: BusinessUnitItemType;
  mode: string | null;
  source: string | null;
};

export const PageBusinessUnitLoader = async (args: any) => {
  try {
    const { businessUnitId } = args.params;
    const url = new URL(args.request.url);
    const mode = url.searchParams.get("mode");
    const source = url.searchParams.get("source");

    if (!businessUnitId) {
      throw new Error("BUSINESS_UNIT_ID_REQUIRED");
    }

    const businessUnit =
      await serviceBusinessUnitsApi.fetchBusinessUnitById(businessUnitId);

    if (!businessUnit) {
      throw new Error("BUSINESS_UNIT_NOT_FOUND");
    }

    return {
      businessUnit,
      mode,
      source,
    } as LoaderDataBusinessUnitType;
  } catch (err) {
    console.error(err);
    throw new Error("BUSINESS_UNIT_NOT_FOUND");
  }
};

export const routersPageBusinessUnit: RouterItemType[] = [
  {
    path: "/businessunits/:businessUnitId",
    authorize: true,
    element: <LayoutPageBusinessUnit />,
    loader: PageBusinessUnitLoader,
  },
  {
    path: "/business-units/:businessUnitId",
    authorize: true,
    element: <LayoutPageBusinessUnit />,
    loader: PageBusinessUnitLoader,
  },
];
